import { createFileRoute } from '@tanstack/react-router';
import { useEffect } from 'react';
import { SettingsScreen } from '@/features/settings/SettingsScreen';
import { useTenant } from '@/lib/tenant';

function SettingsRoute() {
  const { slug } = Route.useParams();
  const { setSlug } = useTenant();
  useEffect(() => {
    setSlug(slug);
  }, [slug, setSlug]);
  return <SettingsScreen slug={slug} />;
}

export const Route = createFileRoute('/tenants/$slug/settings')({
  component: SettingsRoute,
});
